export const PRODUCT_IDENTITY = Object.freeze({
  name: 'Interactive Shell',
  shortName: 'Interactive Shell',
  domain: 'interactiveshell.com',
  origin: 'https://www.interactiveshell.com',
  docsUrl: 'https://www.interactiveshell.com/docs',
  supportUrl: 'https://www.interactiveshell.com/contact',
  protocol: 'web+interactiveshell',
  storagePrefix: 'interactiveshell:',
} as const);
